module.exports = __webpack_public_path__ + "static/media/ic_fax_report.73739a6b.svg";